import React, { Component } from "react";
import firebase from "../../firebase";
import { Modal, Button } from "react-bootstrap";
import "./contact.css";

export default class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalMessage: "", // Dynamic message for modal
    };
  }

  componentDidMount() {
    document.title = "Contact";
  }

  // Close modal
  handleClose = () => {
    this.setState({ showModal: false, modalMessage: "" });
  };

  // Handle form submission
  handleSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission behavior

    const formData = new FormData(event.target);
    const data = {};

    // Iterate through form data and construct object
    formData.forEach((value, key) => {
      data[key] = value;
    });

    // Add data to Firestore
    const db = firebase.firestore();

    // Check for existing email
    db.collection("contacts")
      .where("email", "==", data.email) // Query Firestore for the submitted email
      .get()
      .then((querySnapshot) => {
        if (!querySnapshot.empty) {
          // Email already exists
          this.setState({
            showModal: true,
            modalMessage: "We already have your data. We will contact you soon!",
          });
        } else {
          // Email does not exist; proceed with adding data
          db.collection("contacts")
            .add(data)
            .then(() => {
              console.log("Form data added to Firestore successfully");
              this.setState({
                showModal: true,
                modalMessage:
                  "Your message has been sent successfully. Thank you!",
              });
            })
            .catch((error) => {
              console.error("Error adding form data to Firestore: ", error);
              this.setState({
                showModal: true,
                modalMessage: "An error occurred. Please try again later.",
              });
            });
        }
      })
      .catch((error) => {
        console.error("Error checking for existing email: ", error);
        this.setState({
          showModal: true,
          modalMessage: "An error occurred. Please try again later.",
        });
      });
  };

  render() {
    const { showModal, modalMessage } = this.state;

    return (
      <section id="contact" className="contact">
        <div className="container-fluid mt-5" data-aos="fade-up">
          <div className="section-title">
            <h2>Contact</h2>
          </div>
          <div className="row" data-aos="fade-up" data-aos-delay="100">
            <div className="col-lg-6">
              <div className="row">
                <div className="col-md-12">
                  <div className="info-box">
                    <i className="bx bx-map"></i>
                    <h3>Our Address</h3>
                    <p>HeadQuarters: Charlotte, NC 28277</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="info-box mt-4">
                    <i className="bx bx-envelope"></i>
                    <h3>Email Us</h3>
                    <p>
                      <a
                        className="foot-link"
                        href="mailto:selva.financefrenzy@gmail.com"
                      >
                        Email: selva.financefrenzy@gmail.com
                      </a>
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="info-box mt-4">
                    <i className="bx bx-phone-call"></i>
                    <h3>Call Us</h3>
                    <p>
                      <a className="foot-link" href="tel: +1-972-998-7537">
                        Phone: +1-972-998-7537
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Form Section */}
            <div className="col-lg-6">
              <form
                onSubmit={this.handleSubmit}
                role="form"
                className="php-email-form"
              >
                <div className="row">
                  <div className="col-md-6 form-group">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      id="name"
                      placeholder="Your Name"
                      required
                    />
                  </div>
                  <div className="col-md-6 form-group mt-3 mt-md-0">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      id="email"
                      placeholder="Your Email"
                      required
                    />
                  </div>
                </div>
                <div className="form-group mt-3">
                  <input
                    type="text"
                    className="form-control"
                    name="subject"
                    id="subject"
                    placeholder="Subject"
                    required
                  />
                </div>
                <div className="form-group mt-3">
                  <textarea
                    className="form-control"
                    name="message"
                    rows="7"
                    placeholder="Message"
                    required
                  ></textarea>
                </div>
                <div className="text-center">
                  <button type="submit">Send Message</button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* React-Bootstrap Modal */}
        <Modal show={showModal} onHide={this.handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Notification</Modal.Title>
          </Modal.Header>
          <Modal.Body>{modalMessage}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </section>
    );
  }
}
